export const HIGHLIGHT_STRIPE_WIDTH = 200;